import { ReactComponent as OopsErrorIcon } from "@/assets/icons/oopsErrorIcon.svg";
import Meta from "@/components/Meta";

const AccessDenied = () => {
  return (
    <div className="max-w-96 mx-auto h-full flex justify-center items-center">
      <Meta title="Page Not Found - Trudenty Trust Network Console" />
      <div className="text-center">
        <div className="mx-auto inline-block mb-2">
          <OopsErrorIcon />
        </div>
        <h6 className="mb-3.5 text-xl2 font-medium leading-2xl2 -tracking-0.2 text-body-black">
          Invalid link
        </h6>
        <p className="text-desc-grey text-lg font-medium leading-xl2 -tracking-0.2 ">
          The provided URL is not valid.
        </p>
      </div>
    </div>
  );
};

export default AccessDenied;
